import script from "./paymentResult.vue?vue&type=script&setup=true&lang=js"
export * from "./paymentResult.vue?vue&type=script&setup=true&lang=js"

import "./paymentResult.vue?vue&type=style&index=0&id=e8a74fca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8a74fca"]])

export default __exports__